module.exports = __webpack_public_path__ + "images/ui-icons_ef8c08_256x240.png";